<template>
    <layout>
        <user/> 

        <v-container fluid>
            <v-row class="font-weight-light text-h5 primary--text ml-3">
                <v-col offset="2" offset-md="1">End of Term Report Cards</v-col>
            </v-row>
            <v-row>
                <v-col
                    v-for="(report, index) in reports"
                    :key="index"
                    cols="8" offset="2" md="3" offset-md="1"
                >
                    <v-hover v-slot="{ hover }">
                        <v-card
                            :elevation="hover ? 12 : 2"
                            :class="{ 'on-hover' : hover}"
                                                       
                        >
                            <div 
                                style="height:180px; overflow:hidden; position:relative" 
                                @click="displayReportCard(report)" 
                                :disabled="report.diabled"
                            >
                                <div v-if="report.disabled" class="d-flex justify-center mt-3 blue-grey--text ">Report Not Published</div>
                                <object
                                    :data="report.url"
                                    width="100%"
                                    height="250px"
                                    type="application/pdf"
                                    style=""                                
                                    frameborder="0"                                
                                ></object>
                                <v-fade-transition>
                                <v-overlay
                                    v-if="hover"
                                    absolute
                                    color="secondary"
                                ></v-overlay>
                                </v-fade-transition>
                            </div>
                            <v-card-actions>
                            <span class="font-weight-bold primary--text mr-4">{{report.class_id}}</span>
                            <span class="font-weight-light primary--text">{{ report.subtitle }}</span>
                            
                            <v-spacer></v-spacer>
                            
                            <v-btn 
                                tile
                                x-small
                                dark
                                color="primary"
                                :href="report.urlDownload" 
                                :disabled="report.disabled"                                   
                            >
                                <span style="font-size:0.7rem">Download</span>
                                <v-icon small>mdi-download</v-icon>
                            </v-btn>
                           
                            <!-- <span class="font-weight-light" style="font-size: 0.7rem">{{ report.action }}</span> -->
                            </v-card-actions>

                            
                        </v-card>
                    </v-hover>    
                </v-col>
            </v-row>
        </v-container>

       
        <v-dialog
            v-model="reportCard"
            max-width="95vw"
            persistent
        >   
            <v-card
                height="80vh" 
                v-if="reportCard"
            >
                <iframe ref="pdf" style="width:100%; height:100%" frameBorder="0" :src="src" @load="pdfLoaded"></iframe> 
                <v-overlay
                    absolute
                    :value="overlayReport"
                    color="white"
                    opacity="0.60"
                >
                    <v-progress-circular
                        indeterminate
                        size="64"
                        color="primary"
                    ></v-progress-circular>
                </v-overlay>                
            </v-card>
            <v-container
                fluid
                class="pa-0"
            >
                <v-sheet>
                    <v-row
                        justify="end"
                        class="ma-0"
                    >
                        
                        <v-btn                                            
                            color="primary"
                            dark
                            @click="closeReportCard"                                            
                            class="my-2 mr-4"
                        >
                            Close
                        </v-btn>
                        
                    </v-row>
                </v-sheet>
            </v-container>                        
        </v-dialog>               
    </layout>    
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import Layout from './layouts/App';
import User from './User';
export default {
    name: 'TermReport',
    components: {
        Layout,
        User,            
    },       
    computed: {
        ...mapGetters({            
            getUser: 'auth/getUser',
            admin: 'auth/getAdmin'            
        }),
       
        cardTitleClass(){
            return 'primary white--text';
        },

        user () {
            return JSON.parse(this.getUser);
        },
    },
    mounted(){ 
        this.availableReports();        

    },    
    data: () => ({
        reportCard: false,        
        reports: [],
        reportSelected: {
            action: '',
            headline: '',
            subtitle: '',
            title: '',
            term: '',
            year: '',
        },
        src: "",        
        overlay: false,
        overlayReport: false,
    }),
    methods: { 
        ...mapActions({
            getReportTerms: 'report/getReportTerms',
        }),

        ...mapMutations({
            setReportPeriods: 'report/setReportPeriods',
        }),

        closeReportCard () {
            this.src = "";
            this.reportCard = false;
        },

        displayReportCard (report) {
            this.src = process.env.VUE_APP_API_URI + 
            "/api/report-card/" + 
            report.year + "/" + 
            report.term + "/" +
            report.class_id + "/" +
            1 + "/" +
            this.user.student_id;

            if(report.disabled) return;
            this.reportCard = true;
            this.overlayReport = true;
        },

        async availableReports () {            
            this.overlay = true;           
            try {
                const { data } = await this.getReportTerms(this.user.student_id);
                this.createReportList(data);
                this.overlay = false;
            } catch (error) {
                if(error.response) console.log(error.response)
                else console.log(error);
            }
        },

        createReportList (data) {
            let id = 0, reportURI = null;
            data.forEach(record => {
                id++;
                let posted = 'Report posted ' + ((record.date_posted == null) ? '' : record.date_posted);
                let recordPosted = true, termName = '', recordStyle = '';
                
                if(record.posted == 0){
                    posted = 'Report not posted';    
                    recordPosted = false;
                    //console.log(this.admin);
                    if(this.admin) recordPosted = true;
                    recordStyle = 'background: gainsboro'
                }
                
                reportURI = process.env.VUE_APP_API_URI + 
                "/api/report-card/" + 
                record.year + "/" + 
                record.term + "/" +
                record.class_id + "/" +
                1 + "/" +
                this.user.student_id;
                
                this.reports.push({
                    id: id,                    
                    action: posted,
                    title: 'Form ' + record.form_level + ' ' + record.class_id,
                    headline: 'End of Term Report',
                    subtitle: 'Term ' + record.term + ', ' + termName + ' ' + record.year + '-' + (parseInt(record.year) + 1),
                    term: record.term,
                    year: record.year,
                    disabled: !recordPosted,
                    style: recordStyle,
                    class_id: record.class_id,
                    url: reportURI,
                    urlDownload: reportURI + "/D",
                    ref: 'ref'+id,
                })
            })
           
        }, 
        
        pdfLoaded () {
            this.overlayReport = false;
        }
    }

   
    
}
</script>

<style scoped>
    .v-card{
        cursor: pointer;
    }
</style>